
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","width":"18","height":"18","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Material-Icons"}},[_c('g',{attrs:{"id":"desc"}},[_c('path',{attrs:{"id":"Shape","fill":"#C2C6DC","d":"M10 15V6l4 4 1-1-6-6-6 6 1 1 4-4v9z"}})])])])
          )
        }
      }
    